import type { CSSObject } from '@emotion/react'
import { Color, Size, Spacing } from '@opallabs/gem'

const background: CSSObject = {
  blockSize: Spacing.XS * 21,
  borderRadius: Size.Rounding,
  inlineSize: '100%',
  backgroundColor: Color.light.Surface.N000,
}

const base: CSSObject = {
  backgroundColor: Color.light.Translucent.A04,
  blockSize: Spacing.XS * 21,
  borderRadius: Size.Rounding,
  boxSizing: 'border-box',
  inlineSize: '100%',
  padding: Spacing.XS,
}

const outline: CSSObject = {
  alignItems: 'center',
  backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='2' ry='2' stroke='%232A70EA' stroke-width='2' stroke-dasharray='8%2c 6' stroke-dashoffset='4' stroke-linecap='square'/%3e%3c/svg%3e")`,
  blockSize: '99.9%',
  borderRadius: Size.Rounding / 2,
  boxSizing: 'border-box',
  display: 'flex',
  inlineSize: '99.9%',
  justifyContent: 'space-around',
  padding: Spacing.M,
  '> span': {
    width: '100%',
  },
}

const buttonOverrides: CSSObject = {
  '&:hover': {
    border: `solid 1px ${Color.light.Surface.A200}`,
  },
}

export const styles = {
  background,
  base,
  buttonOverrides,
  outline,
}
